import { useState } from "react";
import Button, { type ButtonProps } from "../../core/button/Button";
import Dropdown from "../../core/dropdown/Dropdown";
import Icon from "../../core/icon/Icon";
import InvisibleInput from "../../core/inputs/InvisibleInput";

export const MagicButton = ({
  onClick,
  leadingIcon = "plus-md",
  variant,
  multipleOptions,
  ...props
}: {
  show?: boolean;
  multipleOptions?: boolean;
} & React.HTMLAttributes<HTMLDivElement> &
  ButtonProps) => {
  const [prompt, setPrompt] = useState("");
  if (props.show === false) return null;

  if (multipleOptions) {
    return (
      <div {...props}>
        <Dropdown
          leadingIcon={leadingIcon}
          size="md"
          variant={variant}
          {...props}
          items={[
            {
              leadingIcon: "reload",
              text: "Neu generieren",
              size: "md",
              value: "new",
              onClick: () => onClick?.("regenerate"),
            },

            {
              leadingIcon: "plus-md",
              text: "Weitere Optionen generieren",
              size: "md",
              value: "more",
              onClick: () => onClick?.("more"),
            },
            {
              children: (
                <div className="bg-surface-subdued border-t -mx-1 -mb-1 py-1">
                  <div className="flex flex-row gap-3 shrink-0 items-center">
                    <Icon
                      name="connection"
                      className="border-border-hovered shrink-0 -mt-1 ml-5"
                    />
                    <InvisibleInput
                      value={prompt}
                      onChange={(e) => {
                        setPrompt(e.target.value);
                      }}
                      onkeydown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          onClick?.(`specific: ${prompt}`);
                        }
                      }}
                      placeholder="Beschreibe deine spezifischen Anforderungen oder Wünsche"
                    />

                    {prompt && (
                      <Button
                        variant="primary"
                        size="md"
                        leadingIcon="checkmark-sm"
                        onClick={() => onClick?.(`specific: ${prompt}`)}
                      />
                    )}
                  </div>
                </div>
              ),
            },
          ]}
        />
      </div>
    );
  }

  return (
    <div {...props}>
      <Button
        leadingIcon={leadingIcon}
        size="md"
        variant={variant}
        onClick={onClick}
        {...props}
      />
    </div>
  );
};

export default MagicButton;
